import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { Db } from "./../../firebase";

const EventPage = () => {
  const { id } = useParams();
  const [event, setEvent] = useState(null);

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        const docRef = doc(Db, "event_photos", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setEvent({ id: docSnap.id, ...docSnap.data() });
        } else {
          console.error("❌ Το event δεν βρέθηκε");
        }
      } catch (error) {
        console.error("🔥 Σφάλμα φόρτωσης event:", error);
      }
    };

    fetchEvent();
  }, [id]);

  if (!event) {
    return (
      <div className="container text-center text-light py-5">
        <h2>Φόρτωση...</h2>
      </div>
    );
  }

  const photos = event.images || [];

  return (
    <section className="py-5" style={{ backgroundColor: "#0b0b0b" }}>
      <div className="container text-light">
        <h2 className="fw-bold text-uppercase mb-4">{event.title || "Untitled Event"}</h2>
        <p className="text-secondary mb-3">
          Ημερομηνία: {event.date || "Χωρίς ημερομηνία"}
        </p>

        <div className="row g-3">
          {photos.map((photo, index) => (
            <div className="col-md-4 col-sm-6" key={index}>
              <img
                src={photo}
                alt={`Photo ${index + 1}`}
                className="img-fluid rounded shadow"
                style={{
                  width: "100%",
                  height: "300px",
                  objectFit: "cover",
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventPage;
